// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17ktz","col":"styles_col__iZfwa"};